import { useState } from 'react';

import { useGraphQLQuery } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { AccountBalanceIconWithModal } from './components/AccountBalanceIconWithModal';
import { DirectTradingAccountPerformanceDocument } from './graphql/directTradingAccountPerformance.generated';

import { DateRangeOption } from '../../../../graphql/schema';
import { PerformanceSection } from '../../../../Shared/components-v2/charts/performance-chart/PerformanceSection';
import { DateRangeOptions } from '../../../../Shared/models/date-range-options';
import { PerformanceLoadingState } from '../managed-account-overview/components/balance-toggle-view/loading-state/PerformanceLoadingState';

export const DirectTradingAccountOverview = () => {
  const accountId = useRequiredParam('accountId');
  const [dateRangeOption, setDateRangeOption] = useState<DateRangeOption>(DateRangeOption.AllTime);

  const {
    data: newData,
    loading,
    previousData,
  } = useGraphQLQuery(DirectTradingAccountPerformanceDocument, {
    variables: { id: accountId, dateRangeOption },
  });

  const data = newData ?? previousData;

  if (loading && !data) return <PerformanceLoadingState />;
  if (!data || data.account.__typename !== 'DirectTradingAccount') return null;

  const directTradingAccount = data.account;

  const { balance, pendingInflowAmount, performance } = directTradingAccount;
  const { totals, simpleRateOfReturn } = performance;
  const { earned } = totals;

  const isLoadingWithPreviousData = loading && !newData && !!previousData;

  const balanceTooltip = (
    <AccountBalanceIconWithModal balance={balance.cents} pendingInflowAmount={pendingInflowAmount.cents} />
  );

  return (
    <PerformanceSection
      balance={balance}
      earned={earned}
      detailsUrl={null}
      timeSeries={performance.history.timeSeries}
      isLoading={isLoadingWithPreviousData}
      dateRangeOption={dateRangeOption}
      dateRangeOptions={DateRangeOptions.throughPastYear}
      onDateRangeChange={setDateRangeOption}
      totalReturnPercent={simpleRateOfReturn}
      disclosures={{
        recencyDescription: performance.history.recencyDescription,
        performanceDisclosure: data.disclosures.directTradingAccountPerformanceDisclosure,
      }}
      balanceTooltip={balanceTooltip}
    />
  );
};
